import { config } from '../../config/config';
import { Observable } from 'rxjs';
import { utilService } from '../utils';
import { windowTime } from 'rxjs/operators';

export const schoolPsychologyService = {
    saveSchoolPsychologyRequest,
    getSchoolPsychologyRequest,
};


function saveSchoolPsychologyRequest(data) {
    return Observable.create((observer) => {
        fetch(config.api_url + config.url.schoolPsychologyRequest + data.pathparams + data.params, {
            method: data.method,
            headers: {
                Authorization: data.token,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data.data),
        })
            .then(utilService.handleResponse)
            .then((result) => {
                // console.log('result....', result)
                observer.next(result);
                observer.complete();
            })
            .catch((error) => {
                if (error.status === 401) {
                    window.location.reload();
                } else {
                    console.log('error......', error)
                    if (error.status === 400 && error.message === '[ERROR] Subscribed user already exist in database') {
                        observer.error(error.message);
                    }
                }
            });
    });
}


function getSchoolPsychologyRequest(data) {
    return Observable.create((observer) => {
        fetch(config.api_url + config.url.schoolPsychologyRequest + data.params, {
            method: 'GET',
            headers: {
                Authorization: data.token,
            },
        })
            .then(utilService.handleResponse)
            .then((result) => {
                observer.next(result);
                observer.complete();
            })
            .catch((error) => {
                if (error.status === 401) {
                    window.location.reload();
                } else {
                    observer.error(error.message);
                }
            });
    });
}